import _asyncToGenerator from "/home/runner/work/graphiql-console/graphiql-console/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/graphiql-console/graphiql-console/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _awaitAsyncGenerator from "/home/runner/work/graphiql-console/graphiql-console/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator";
import _wrapAsyncGenerator from "/home/runner/work/graphiql-console/graphiql-console/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator";
var separator = '\r\n\r\n';
var decoder = new TextDecoder();

function generate(_x, _x2, _x3) {
  return _generate.apply(this, arguments);
}
/**
 * Yield immediately for every part made available on the response. If the `content-type` of the response isn't a
 * multipart body, then we'll resolve with {@link Response}.
 *
 * @example
 *
 * ```js
 * const parts = await fetch('/fetch-multipart')
 *      .then(meros);
 *
 * for await (const part of parts) {
 *     // do something with this part
 * }
 * ```
 */


function _generate() {
  _generate = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stream, boundary, options) {
    var reader, is_eager, buffer, is_preamble, payloads, result, chunk, idx_chunk, idx_boundary, current, next, headers, idx_headers, arr_headers, tmp, body, is_json;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            reader = stream.getReader(), is_eager = !options || !options.multiple;
            buffer = '', is_preamble = true, payloads = [];
            _context.prev = 2;

          case 3:
            _context.next = 5;
            return _awaitAsyncGenerator(reader.read());

          case 5:
            if ((result = _context.sent).done) {
              _context.next = 46;
              break;
            }

            chunk = decoder.decode(result.value);
            idx_chunk = chunk.indexOf(boundary);
            idx_boundary = buffer.length;
            buffer += chunk;

            if (!!~idx_chunk) {
              // chunk itself had `boundary` marker
              idx_boundary += idx_chunk;
            } else {
              // search combined (boundary can be across chunks)
              idx_boundary = buffer.indexOf(boundary);
            }

            payloads = [];

          case 12:
            if (!~idx_boundary) {
              _context.next = 41;
              break;
            }

            current = buffer.substring(0, idx_boundary);
            next = buffer.substring(idx_boundary + boundary.length);

            if (!is_preamble) {
              _context.next = 19;
              break;
            }

            is_preamble = false;
            _context.next = 37;
            break;

          case 19:
            headers = {};
            idx_headers = current.indexOf(separator);
            arr_headers = buffer.slice(0, idx_headers).toString().trim().split(/\r\n/); // parse headers

            tmp = void 0;

            while (tmp = arr_headers.shift()) {
              tmp = tmp.split(': ');
              headers[tmp.shift().toLowerCase()] = tmp.join(': ');
            }

            body = current.substring(idx_headers + separator.length, current.lastIndexOf('\r\n'));
            is_json = false;
            tmp = headers['content-type'];

            if (tmp && !!~tmp.indexOf('application/json')) {
              try {
                body = JSON.parse(body);
                is_json = true;
              } catch (_) {}
            }

            tmp = {
              headers: headers,
              body: body,
              json: is_json
            };

            if (!is_eager) {
              _context.next = 34;
              break;
            }

            _context.next = 32;
            return tmp;

          case 32:
            _context.next = 35;
            break;

          case 34:
            payloads.push(tmp);

          case 35:
            if (!(next.substring(0, 2) === '--')) {
              _context.next = 37;
              break;
            }

            return _context.abrupt("break", 46);

          case 37:
            buffer = next;
            idx_boundary = buffer.indexOf(boundary);
            _context.next = 12;
            break;

          case 41:
            if (!payloads.length) {
              _context.next = 44;
              break;
            }

            _context.next = 44;
            return payloads;

          case 44:
            _context.next = 3;
            break;

          case 46:
            _context.prev = 46;

            if (!payloads.length) {
              _context.next = 50;
              break;
            }

            _context.next = 50;
            return payloads;

          case 50:
            reader.releaseLock();
            return _context.finish(46);

          case 52:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2,, 46, 52]]);
  }));
  return _generate.apply(this, arguments);
}

function meros(_x4, _x5) {
  return _meros.apply(this, arguments);
}

function _meros() {
  _meros = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(response, options) {
    var ctype, idx_boundary;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!response.ok || !response.body || response.bodyUsed)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", response);

          case 2:
            ctype = response.headers.get('content-type');

            if (!(!ctype || !~ctype.indexOf('multipart/mixed'))) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", response);

          case 5:
            idx_boundary = ctype.indexOf('boundary=');
            return _context2.abrupt("return", generate(response.body, "--".concat(!!~idx_boundary ? // +9 for 'boundary='.length
            ctype.substring(idx_boundary + 9).trim().replace(/['"]/g, '') : '-'), options));

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _meros.apply(this, arguments);
}

export { meros };